interface IHistory {
  id: string;
  alertcase_id: string;
  date: string;
  user_name: string;
  action: string;
  user_id: string;
}

export function transformToBackendHistory(data: IHistory) {
  return data;
}

export function transformFromBackendHistory(backendType: IHistory[]) {
  return backendType.map(history => ({
    id: history.id,
    alertcase_id: history.alertcase_id,
    date: history.date,
    user_id: history.user_id,
    user_name: history.user_name,
    action: history.action
  }));
}
